<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Subscription Plans' : 'Deleted Subscription Plans'"
              ></h3>
              <template v-if="isDeletePage() != true">
                <v-btn v-can:add="'plans'"
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/plans/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
                <v-btn v-can:add="'plans'"
                  class="mx-2 mb-2"
                  rounded
                  small
                  color="primary"
                  outlined
                  to="/zone-commission-settings"
                >
                  <v-icon left> mdi-map-marker-multiple </v-icon>
                  Zone Commission Settings
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    hide-details="auto"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    @click:clear="(filter.is_active = null), (page = 1)"
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Active Status"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="4">
                  <v-autocomplete
                    ref="no_of_dogs"
                    solo
                    hide-details="auto"
                    rounded
                    :loading="isMasterLoading"
                    v-model="filter.no_of_dogs"
                    label="No.Of Dogs *"
                    :items="dogCount"
                    prepend-inner-icon="mdi-dog"
                    clearable
                    @input="(page = 1), getData()"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="4">
                  <v-autocomplete
                    ref="no_of_walks"
                    solo
                    hide-details="auto"
                    rounded
                    :loading="isMasterLoading"
                    v-model="filter.no_of_walks"
                    label="No.Of Walks *"
                    :items="walkCount"
                    prepend-inner-icon="mdi-walk"
                    clearable
                    @input="(page = 1), getData()"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="4">
                  <v-autocomplete
                    ref="plan_tier"
                    solo
                    hide-details="auto"
                    rounded
                    :loading="isMasterLoading"
                    v-model="filter.tier"
                    label="Tier *"
                    :items="plan_tierItems"
                    prepend-inner-icon="mdi-equalizer"
                    clearable
                    @input="(page = 1), getData()"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 575px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="575"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: none">
                        No.Of Dogs
                      </th>
                      <th class="text-left" style="min-width: none">
                        No.Of Walks
                      </th>
                      <th class="text-left" style="min-width: none">Tier</th>
                      <th class="text-left" style="min-width: none">
                        Original Amount
                      </th>
                      <th class="text-left" style="min-width: 102px">
                        Price Percent [%]
                      </th>
                      <th class="text-left" style="min-width: 102px">
                        Discount Percent [%]
                      </th>
                      <th class="text-left" style="min-width: 120px">
                        Calculated Final Amount
                      </th>
                      <th class="text-left" style="min-width: 136px">
                        Second Discount Percent [%]
                      </th>
                      <th class="text-left" style="min-width: 136px">
                        Second Discount Amount
                      </th>
                      <th class="text-left" style="min-width: 105px">
                        Actual Final Amount
                      </th>
                      <th class="text-left" style="min-width: 87px">
                        Per Walk Time
                      </th>
                      <th class="text-left" style="min-width: none">Days</th>
                      <th class="text-left" style="min-width: 117px">
                        Customer Per Day Charges
                      </th>
                      <th class="text-left" style="min-width: 160px">
                        Created At
                      </th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="plans.length != 0">
                    <tr
                      v-for="(plan, i) in plans"
                      :key="`plan_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': plans.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="plan.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Plan is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="plan.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Plan is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>{{ plan.no_of_dogs || "" }}</td>
                      <td>{{ plan.no_of_walks || "" }}</td>
                      <td>{{ plan.tier || "" }}</td>
                      <td>{{ plan.original_amount || "" }}</td>
                      <td>{{ plan.price_percent || "" }}%</td>
                      <td>{{ plan.discount_percent || "" }}%</td>
                      <td>{{ plan.calculated_final_amount || "" }}</td>
                      <td>{{ plan.second_discount_percent || "" }}</td>
                      <td>{{ plan.second_discount_amount || "" }}</td>
                      <td>{{ plan.final_amount || "" }}</td>
                      <td>{{ plan.per_walk_time || "" }}</td>
                      <td>{{ plan.days || "" }}</td>
                      <td>{{ plan.customer_per_day_charges || "" }}</td>
                      <td style="min-width: 160px">
                        {{ formatDate(plan.created_at) }}
                      </td>
                      <td class="text-right" style="min-width: 195px">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'plans'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="OpenWarning(plan.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Plan</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/plans/${encryptIt(
                                  plan.id
                                )}/zone-commissions`"
                              >
                                <v-icon dark> mdi-eye </v-icon>
                              </v-btn>
                            </template>
                            <span>View Commissions</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/plan-time-slots?plan_id=${encryptIt(
                                  plan.id
                                )}`"
                              >
                                <v-icon dark> mdi-clock-outline </v-icon>
                              </v-btn>
                            </template>
                            <span>View Time Slots</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                @click="openHistory(plan.id)"
                              >
                                <v-icon dark> mdi-history </v-icon>
                              </v-btn>
                            </template>
                            <span>View Change History</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/plans/${encryptIt(plan.id)}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Plan</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'plans'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(plan.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this plan</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="100" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_plan" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Plan deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_plan = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_restored_plan" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Plan restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_plan = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Delete Warning Dialog Box -->
      <v-dialog v-model="deleteDialog" width="550px">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 150px"
                >
                  mdi-delete-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>Are you sure you want to delete this?</h3>
                      <br />
                      <v-btn color="grey" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="red"
                        dark
                        class="ml-5"
                        @click="
                          Delete_this(to_be_deleted_id), (deleteDialog = false)
                        "
                        >Delete</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Change History -->
      <v-dialog v-model="historyDialog" max-width="720">
        <v-card class="plan-history">
          <div class="plan-history__head">
            <h2>Plan Change History</h2>
            <v-btn icon @click="historyDialog = false"><v-icon>mdi-close</v-icon></v-btn>
          </div>
          <div v-if="historyLoading" class="plan-history__loading">
            <v-progress-circular indeterminate size="28" width="2" color="primary"></v-progress-circular>
          </div>
          <div v-else-if="!history.length" class="plan-history__empty">
            No changes recorded yet for this plan.
          </div>
          <div v-else class="plan-history__list">
            <div v-for="h in history" :key="h.id" class="plan-history__row">
              <div class="plan-history__meta">
                <span class="plan-history__date">{{ dateTime(h.changed_at) }}</span>
                <span v-if="h.changed_by" class="plan-history__by">by {{ h.changed_by }}</span>
              </div>
              <table class="plan-history__table">
                <thead>
                  <tr>
                    <th>Field</th>
                    <th>Before</th>
                    <th>After</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="c in h.changes" :key="c.field">
                    <td>{{ c.label }}</td>
                    <td class="plan-history__old">{{ displayValue(c.old) }}</td>
                    <td class="plan-history__new">{{ displayValue(c.new) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "plansPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        show_deleted: false,
      },
      plans: [],
      statuses: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      dogCount: [1, 2],
      walkCount: [1, 2],
      plan_tierItems: [],
      ExportPlanTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      isMasterLoading: false,
      isExcelloading: false,
      delete_plan: false,
      is_deleted_plan: false,
      restore_plan: false,
      is_restored_plan: false,
      deleteDialog: false,
      to_be_deleted_id: "",
      historyDialog: false,
      historyLoading: false,
      history: [],
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getMasters();
    },
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        return value;
      }
    },
    OpenWarning(request_id) {
      this.to_be_deleted_id = request_id;
      this.deleteDialog = true;
    },
    async getMasters() {
      this.isMasterLoading = true;
      await axios
        .get(`masters?context=plans`)
        .then((masters) => {
          masters = masters.data;
          //Position
          masters.plan_tiers.forEach((plan_tier) => {
            this.plan_tierItems.push({
              id: plan_tier.id,
              text: plan_tier.description,
              value: plan_tier.description,
            });
          });
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isMasterLoading = false;
      this.getData();
    },
    async getData() {
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.no_of_dogs = this.filter.no_of_dogs
        ? this.filter.no_of_dogs
        : "";
      this.filter.no_of_walks = this.filter.no_of_walks
        ? this.filter.no_of_walks
        : "";
      this.filter.tier = this.filter.tier ? this.filter.tier : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&no_of_dogs=" +
        this.filter.no_of_dogs +
        "&no_of_walks=" +
        this.filter.no_of_walks +
        "&tier=" +
        this.filter.tier +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`plans?${query}`)
        .then((response) => {
          this.plans = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(`plan_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async Delete_this(id) {
      this.delete_plan = true;
      await axios
        .post(`/plans/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_plan = false;
          this.is_deleted_plan = true;
          this.getData();
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
    },
    async Restore_this(id) {
      this.restore_plan = true;
      await axios
        .post(`/plans/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_plan = false;
          this.is_restored_plan = true;
          this.getData();
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
    },
    dateTime(v) {
      return new Date(v).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
    displayValue(v) {
      if (v === null || v === undefined || v === "") return "—";
      if (Array.isArray(v)) return v.length ? v.join(", ") : "—";
      if (v === true) return "Yes";
      if (v === false) return "No";
      return v;
    },
    async openHistory(id) {
      this.historyDialog = true;
      this.historyLoading = true;
      await axios
        .get(`/plans/${this.encryptIt(id)}/history`)
        .then((response) => {
          this.history = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
      this.historyLoading = false;
    },
  },
};
</script>

<style scoped>
.plan-history {
  padding: 18px 22px 22px;
}

.plan-history__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.plan-history__head h2 {
  font-size: 1.1rem;
  font-weight: 700;
}

.plan-history__loading,
.plan-history__empty {
  display: flex;
  justify-content: center;
  padding: 32px 0;
  color: #66738a;
  font-size: 0.875rem;
}

.plan-history__list {
  max-height: 60vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.plan-history__row {
  border: 1px solid #e4e8ee;
  border-radius: 10px;
  padding: 10px 14px;
}

.plan-history__meta {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.8rem;
  color: #66738a;
  margin-bottom: 8px;
}

.plan-history__date {
  font-weight: 700;
  color: #1a2436;
}

.plan-history__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem;
}

.plan-history__table th {
  text-align: left;
  color: #8d99ad;
  font-weight: 600;
  padding: 4px 8px;
}

.plan-history__table td {
  padding: 4px 8px;
  border-top: 1px solid #f0f2f5;
}

.plan-history__old {
  color: #9aa3b2;
  text-decoration: line-through;
}

.plan-history__new {
  color: #15803d;
  font-weight: 700;
}
</style>
